module.exports = __webpack_public_path__ + "8e1da7ff36610273107f181890849565.svg";